import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useConfig } from '@/composables/config';

import SmModal from '@/components/ui/SmModal/SmModal.vue';
import AddIdentForm from '@/components/common/AddIdent/AddIdentForm.vue';

type IsShowModal = boolean;
interface IProps {
  modelValue: IsShowModal;
}
// [END] Types and interfaces

// [START] Variables

export default /*#__PURE__*/_defineComponent({
  __name: 'AddIdentModal',
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "addAccountByIdent"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { t } = useI18n();
const { getAppSettings } = useConfig();

// [START] Types and interfaces
const appSettings = getAppSettings();
const isLegalAccount = appSettings?.allowedAccountTypes === 1
// [END] Variables

// [START] Props

// [END] Props

// [START] Emits

// [END] Emits

// [START] Computed
const show = computed((): IsShowModal => props.modelValue);
const modalTitle = computed(() => isLegalAccount ? t('contract_adding') : t('adding_a_personal_account'))
// [END] Computed

// [START] Methods
const handleCloseModal = (): void => {
  emits('update:modelValue', false);
};

const handleAddAccountByIdent = (): void => {
  emits('update:modelValue', false);
  emits('addAccountByIdent');
};
// [END] Methods

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SmModal, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    onClose: handleCloseModal,
    title: modalTitle.value
  }, {
    body: _withCtx(() => [
      _createVNode(AddIdentForm, {
        onAddAccountByIdent: handleAddAccountByIdent,
        onCloseModal: handleCloseModal
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})